<template>
  <v-menu
    v-model="open"
    :close-on-content-click="false"
    :content-class="contentClass"
    :disabled="disabled"
    @update:model-value="blurOrFocus"
  >
    <template v-slot:activator="{ props: menu }">
      <slot name="activator" v-bind="menu">
        <div
          v-bind="menu"
          class="qtm-menu-select px-3 qtm-border qtm-body text-dark-grey"
          :class="`${activatorClass} ${disabled ? 'disabled' : ''} bg-${bgColor}`"
        >
          <div class="d-flex align-items-center">
            <div class="d-block label">
              <slot name="prepend-label" />
              {{ displayLabel }}
              <span v-if="value" class="text-mid-grey" v-text="value" />
            </div>
            <div class="ml-2">
              <v-icon v-if="open">
                mdi-chevron-up
              </v-icon>
              <v-icon v-else-if="clearable && value" @click.stop="$emit('clear')">
                mdi-close
              </v-icon>
              <v-icon v-else>
                mdi-chevron-down
              </v-icon>
            </div>
          </div>
        </div>
      </slot>
    </template>
    <div class="menu-content">
      <slot />
    </div>
  </v-menu>
</template>

<script setup lang="ts">
export interface Props {
  activatorClass?: string
  bgColor?: string
  clearable?: boolean
  contentClass?: string
  disabled?: boolean
  label: string
  value?: string
  width?: number
}

const props = withDefaults(defineProps<Props>(), {
  activatorClass: undefined,
  bgColor: 'white',
  contentClass: 'bg-white qtm-border',
  value: '',
  width: 286,
})
const emit = defineEmits(['blur', 'clear', 'focus'])

const open = ref(false)

const displayLabel = computed(() => `${props.label}${props.value ? ':' : ''}`)

const blurOrFocus = (value: boolean) => emit(value ? 'focus' : 'blur')

const close = () => {
  open.value = false
}

defineExpose({ close })
</script>

<style lang="scss" scoped>
.qtm-menu-select {
  border-radius: 2px;
  cursor: pointer;
  display: inline-block;
  max-width: v-bind(width)px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-top: 7px;
  padding-bottom: 7px;

  &:hover {
    opacity: 0.7;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.menu-content {
  max-height: 500px;
  max-width: 382px;
  min-width: 300px;
  width: fit-content;
  overflow-y: auto;
}

.label {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
